import { render, staticRenderFns } from "./Mirror.vue?vue&type=template&id=a07fd09c&scoped=true&"
import script from "./Mirror.vue?vue&type=script&lang=js&"
export * from "./Mirror.vue?vue&type=script&lang=js&"
import style0 from "./Mirror.vue?vue&type=style&index=0&id=a07fd09c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a07fd09c",
  null
  
)

export default component.exports